<template>
  <div :style="styles.container">
    <div
      :style="{
        ...styles.drawer,
        height: drawerHeight + 'px',
        transition: isDragging ? 'none' : 'height 0.3s ease',
      }"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div :style="styles.handle" />
      <div
        :style="styles.drawerContent"
      >
        <i
          class="fa-solid fa-xmark fs-2"
          style="position:absolute; right: 20px;top:20px; color: #ccc;"
          @click="drawerHeight=0"
        />
        <div
          v-if="step==0"
          class="mx-3 p-3 mt-5 rounded-3"
          style="background-color: #F5F6F8;"
        >
          <div
            class="d-flex mx-2 "
            @click="expandDrawer(1)"
          >
            <p class=" text-start fw-bold mb-0 pe-2">
              Ubicación:
            </p>
            <p
              class="flex-grow-1 text-end mb-0"
              style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            >
              {{ localInput.address ? localInput.address.street : "" }}<span v-if="localInput.address && localInput.address.address">,</span> {{ localInput.address ? localInput.address.city : "" }}
              
            </p>
            <i
              style="color:#15E0DD" 
              class="fa-solid fa-location-dot mx-2" />
          </div>
          <hr class="mx-4">
          <div
            class="d-flex mx-2 mt-2"
            @click="step = 2; $nextTick(() => { if ($refs.time_component) { $refs.time_component.CambiarHoras(localInput.time); } })"
          >
            <p class=" text-start fw-bold mb-0 pe-2">
              Horario:
            </p>
            <p
              class="flex-grow-1 text-end mb-0"
              style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            >
              <span v-if="localInput.time && (localInput.time.startTime || localInput.weekend_full_day)">
                <span
                  v-if="localInput.time.startTime"
                >
                  L-V
                  <span v-if="localInput.time.startTime == '00:00' && localInput.time.endTime == '00:00'">
                    24h
                  </span>
                  <span v-else>{{ localInput.time.startTime }}h - {{ localInput.time.endTime }}h</span>
                </span>
                <span v-if="localInput.weekend_full_day">S-D 24h</span>
              </span>
            </p>
            <i
              style="color:#15E0DD" 
              class="fa-solid fa-clock mx-2" />
          </div>
          <hr class="mx-4">
          <div
            class="d-flex mx-2 mt-2"
          >
            <p class=" text-start fw-bold mb-0">
              Tamaño:
            </p>
            <div 
              class="flex-grow-1"
              style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
              <p 
                v-if="formattedSize?.length>0"
                class="text-black text-end mb-0">Coche {{ formattedSize }}</p>
            </div>
            <div
              style="color:#15E0DD" 
              class="nav-item dropdown-toggle">
              <a
                style="color:#15E0DD"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
              >
                <i class="fa-solid fa-car ms-2" />
              </a>
              <ul class="dropdown-menu">
                <li @click="localInput.vehicle_size='small'">
                  <a
                    class="dropdown-item"
                    href="#"
                  >Pequeño (3,6 x 1,6m)</a>
                </li>
                <li @click="localInput.vehicle_size='medium'">
                  <a
                    class="dropdown-item"
                    href="#"
                  >Mediano (4,5 x 1,8m)</a>
                </li>
                <li @click="localInput.vehicle_size='large'">
                  <a
                    class="dropdown-item"
                    href="#"
                  >Grande (5,0 x 1,9m)</a>
                </li>
              </ul>
            </div>
          </div>
          <hr 
            class="mx-4" 
            v-if="is_request">
          <div 
            class="d-flex mx-2 m-0" 
            v-if="is_request">
            <p class="d-flex align-items-center text-start fw-bold mb-0">
              Modelo
            </p>
            <input
              id="floatingInput"
              v-model="localInput.vehicle_model"
              class="form-control border-0 mx-3 py-1 px-0 text-end bg-transparent flex-grow-1"
              placeholder="Seat Ibiza..."
            >
          </div>
          <hr 
            class="mx-4" 
            v-if="is_request">
          <div
            class="d-flex mx-2"
            v-if="is_request"
          >
            <span class="fw-bold mb-0 pe-2 ">
              Periodo de alquiler
            </span>
            <div 
              style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              class="flex-grow-1">
              <p 
                v-if="formattedPeriod?.length>0"
                class="text-black text-end">{{ formattedPeriod }}</p>
            </div>
            <div class="nav-item dropdown ">
              <a
                class="nav-link dropdown-toggle"
                style="color:#15E0DD"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
              >
                <i class="fa-regular fa-calendar ms-2" />
              </a>
              <ul class="dropdown-menu">
                <li @click="localInput.duration='1-6months'">
                  <a
                    class="dropdown-item"
                    href="#"
                  >1-6 meses</a>
                </li>
                <li @click="localInput.duration='6-12months'">
                  <a
                    class="dropdown-item"
                    href="#"
                  >6-12 meses</a>
                </li>
                <li @click="localInput.duration='indefinite'">
                  <a
                    class="dropdown-item"
                    href="#"
                  >Indefinido</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-if="step==0"
          class="d-flex mt-4"
        >
          <button
            style="background-color: #15E0DD;"
            class="btn fw-semibold mx-auto"
            @click="update_filters()"
          >
            Actualizar
          </button>
        </div>
        <div
          v-if="step==1"
          class="px-5"
          style="height: calc(100vh - 15px);"
        >
          <i
            v-if="!individual_step"
            class="fa-solid fa-arrow-left fs-3"
            style="position:absolute; left: 20px;top:20px; color: #ccc;"
            @click="drawerHeight= 500;step=0"
          />
          <address-browser-component
            v-if="is_parker"
            text="Indica la dirección de tu garaje"
            title="¿Dónde está tu garaje?"
            :address="localInput.address"
            :is_parker="is_parker"
            @get-data-address="handleGetAddress"
          />
          <address-browser-component
            v-else
            text="Indica tu dirección de búsqueda"
            text2="Buscaremos garajes a máximo 10 minutos andando de tu ubicación"
            title="¿Dónde necesitas un garaje?"
            :address="localInput.address"
            :is_parker="is_parker"
            @get-data-address="handleGetAddress"
          />
        </div>
        <div
          v-if="step==2"
          class="px-4 mt-5"
        >
          <i
            v-if="!individual_step"
            class="fa-solid fa-arrow-left fs-3"
            style="position:absolute; left: 20px;top:20px; color: #ccc;"
            @click="(localWeekDays || localInput.weekend_full_day) ? (drawerHeight= 500, step=0, hour_error = false) : (hour_error = true)"
          />
          <p
            style="color:#011638; font-weight: 500; font-size: 1.2rem;"
            class="ms-3"
          >
            Disponibilidad
          </p>
          <div
            class="row m-0 mt-2"
            style="color:#011638"
          >
            <div class="row m-0 bg-white rounded-top-4 py-3">
              <span class="col">Lunes a viernes </span>
              <div class="form-check form-switch col-2 d-flex justify-content-end">
                <input
                  id="flexSwitchCheckDefault"
                  v-model="localWeekDays"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                >
              </div>
            </div>
            <div
              v-if="!localFullDay && localWeekDays"
              class="row m-0 bg-white py-3 ps-4"
            >
              <span class="col">Franja horaria</span>
              <time-component
                ref="time_component"
                class="col"
                :es-deshabilitado="localFullDay"
                @get-data-horas="handleGetDataHoras"
              />
            </div>
          </div>
          <div
            v-if="localWeekDays && is_parker"
            class="row m-0 bg-white rounded-bottom-4 py-3 ps-4 pe-2"
          >
            <span class="col">Día entero (24h)</span>
            <div class="form-check form-switch col-2 d-flex justify-content-end me-1">
              <input
                id="flexSwitchCheckDefault"
                v-model="localFullDay"
                class="form-check-input"
                type="checkbox"
                role="switch"
              >
            </div>
          </div>
          <div
            class="row m-0 mt-2"
            style="color:#011638"
          >
            <p
              style="color:#56647A"
              class="mb-1"
            />
            <div class="row m-0 bg-white rounded-3 py-3">
              <span class="col">Sábado y domingo (24h)</span>
              <div class="form-check form-switch col-2 d-flex justify-content-end">
                <input
                  id="flexSwitchCheckDefault"
                  v-model="localInput.weekend_full_day"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                >
              </div>
            </div>
          </div>
          <p
            v-if="hour_error"
            class="text-danger text-center mt-3"
          >
            Introduce un horario correcto
          </p>
          <div
            v-if="individual_step"
            class="d-flex mt-4"
          >
            <button
              style="background-color: #15E0DD;"
              class="btn fw-semibold mx-auto"
              @click="(localWeekDays || localInput.weekend_full_day) ? (console.log(localInput),update_filters(), hour_error = false) : (hour_error = true)"
            >
              Actualizar
            </button>
          </div>
          <div
            v-else
            class="d-flex mt-4"
          >
            <button
              style="background-color: #15E0DD;"
              class="btn fw-semibold mx-auto"
              @click="(localWeekDays || localInput.weekend_full_day) ? (drawerHeight= 500, step=0, hour_error = false) : (hour_error = true)"
            >
              Confirmar Horario
            </button>
          </div>
        </div>
        <div
          v-if="step==3"
          class="px-4 mt-5"
        >
          <i
            v-if="!individual_step"
            class="fa-solid fa-arrow-left fs-3"
            style="position:absolute; left: 20px;top:20px; color: #ccc;"
            @click="drawerHeight= 500;step=0"
          />
          <p
            style="color:#011638; font-weight: 500; font-size: 1.2rem;"
            class="ms-3"
          >
            Tamaño
          </p>
          <div class="mt-3 ms-2 bg-white ps-3 rounded-4">
            <div
              class="row m-0"
              @click="localInput.vehicle_size='small'"
            >
              <p
                class="py-3 mb-0 col-10"
                style="color:#8E97A7"
              >
                Coche pequeño (3,6 x 1,6m)
              </p>
              <i
                v-if="localInput.vehicle_size=='small'"
                class="fa-solid fa-check col-2 d-flex align-items-center"
                style="color:#15E0DD"
              />
            </div>
            <hr class="my-0">
            <div
              class="row m-0"
              @click="localInput.vehicle_size='medium'"
            >
              <p
                class="py-3 mb-0 col-10"
                style="color:#8E97A7"
              >
                Coche mediano (4,5 x 1,8m)
              </p>
              <i
                v-if="localInput.vehicle_size=='medium'"
                class="fa-solid fa-check col-2 d-flex align-items-center"
                style="color:#15E0DD"
              />
            </div>
            <hr class="my-0">
            <div
              class="row m-0"
              @click="localInput.vehicle_size='large'"
            >
              <p
                class="py-3 mb-0 col-10"
                style="color:#8E97A7"
              >
                Coche grande (5,0 x 1,9m)
              </p>
              <i
                v-if="localInput.vehicle_size=='large'"
                class="fa-solid fa-check col-2 d-flex align-items-center"
                style="color:#15E0DD"
              />
            </div>
          </div>
          <div
            v-if="individual_step"
            class="d-flex mt-4"
          >
            <button
              style="background-color: #15E0DD;"
              class="btn fw-semibold mx-auto"
              @click="update_filters()"
            >
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <script>
  import AddressBrowserComponent from './AddressBrowserComponent.vue';
  import TimeComponent from '../components/TimeComponent.vue'
  import { formatPeriod, formatSize } from '../services/traslation';


  export default {
    name: 'DrawerComponent',
    components: {
        AddressBrowserComponent,
        TimeComponent
    },
    props: {
        input:{
            type: Object,
            required: true,
        },
        individual_step:{
            type: Boolean,
            required: false,
        },
        is_parker:{
            type: Boolean,
            required: false,
        },
        is_request:{
            type: Boolean,
            required: false,
        },
        full_day:{
            type: Boolean,
            required: false,
        },
        weekdays:{
            type: Boolean,
            required: false,
        },
    },
    data() {
      return {
        drawerHeight: 0, // Altura inicial
        isDragging: false, // Si el usuario está arrastrando
        step:0,
        localInput: {},
        localFullDay: false,
        localWeekDays: true,
        hour_error: false
      };
    },
    computed: {
      styles() {
        return {
          container: {
            position: 'relative',
            maxheight: '100vh',
            backgroundColor: '#f5f5f5',
            overflow: 'hidden',
          },
          drawer: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: '#fff',
            boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.2)',
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          },
          handle: {
            width: '50px',
            height: '6px',
            backgroundColor: '#ccc',
            borderRadius: '3px',
            margin: '10px 0',
          },
          drawerContent: {
            padding: '0px',
            width: "100%"
          },
        };
      },
      formattedSize() {
        return formatSize(this.localInput.vehicle_size);
      },
      formattedPeriod(){
        return formatPeriod(this.localInput.duration)
      }
    },
    watch :{
      input: {
        immediate: true, // Se ejecuta al inicio
        handler(newVal) {
          this.localInput = structuredClone(newVal);
          if(!this.localInput.address){
            this.localInput.address = {}
          }
          if(!this.localInput.time){
            this.localInput.time = {}
          }
        }
      },
      full_day: {
        immediate: true, // Se ejecuta al inicio
        handler(newVal) {
          this.localFullDay = newVal;
        }
      },
      weekdays: {
        immediate: true, // Se ejecuta al inicio
        handler(newVal) {
          this.localWeekDays = newVal;
        }
      },
      localWeekDays(){
        if(this.localWeekDays){
          this.localInput.time.startTime="08:00"
          this.localInput.time.endTime="18:00"
        }else{
          this.localInput.time.startTime=null
          this.localInput.time.endTime=null
          this.localFullDay = false
        }
        this.$nextTick(() => { if (this.$refs.time_component) { this.$refs.time_component.CambiarHoras(this.localInput.time); } })
      },
      localFullDay(){
        if(this.localFullDay){
          this.localInput.time.startTime="00:00"
          this.localInput.time.endTime="00:00"
        }else{
          if(this.localWeekDays){
            this.localInput.time.startTime="08:00"
            this.localInput.time.endTime="18:00"
          }else{
            this.localInput.time.startTime=null
            this.localInput.time.endTime=null
          }
        }
        try{
          this.$refs.time_component.CambiarHoras(this.localInput.time)
        }catch{
          console.log("Input horas no encontrado")
          console.log(this.localInput)
        }
      },
      drawerHeight(){
        if(this.drawerHeight == 0){
          this.step = 0
        }
      }
    },
    methods: {
        handleGetAddress(address){
            this.localInput.address.address = address.address;
            this.localInput.address.center = address.center;
            this.localInput.address.city = address.city;
            this.localInput.address.street = address.street;
            this.localInput.address.state = address.state;
            this.localInput.address.zip_code = address.zip_code;

            if(!this.individual_step){
              this.drawerHeight = 500

              this.step = 0;
            }else{
              this.update_filters()
            }

        },
        handleGetDataHoras(time){
          console.log("AUN NO HAN CAMBIADO LAS HORAS", this.localInput)
          console.log("HAN CAMBIADO LAS HORAS", time)
          this.localInput.time.startTime = time.startTime
          this.localInput.time.endTime = time.endTime
          console.log("YA HAN CAMBIADO LAS HORAS", this.localInput)
        },
        expandDrawer(step){
            this.step = step
            this.drawerHeight = window.innerHeight - 60
        },
        openDrawer(){
            this.step = 0
            this.drawerHeight = 500
            console.log(this.localInput, "LOCAL INPUT")
        },
        change_step(step){
          switch(step){
            case 1:
              this.expandDrawer(1)
              break
            case 2:
              this.step = 2
              this.$nextTick(() => { if (this.$refs.time_component) { this.$refs.time_component.CambiarHoras(this.localInput.time); } })
              break
            default:
              this.step = step
          }
        },
      handleTouchStart() {
        this.isDragging = true;
      },
      handleTouchMove(event) {
        if (event.target.closest('.leaflet-container')) {
          return;
        }
        if (this.isDragging) {
          const touchY = event.touches[0].clientY;
          const screenHeight = window.innerHeight - 60;
          const newHeight = screenHeight - touchY;

          if (newHeight >= 100 && newHeight <= screenHeight) {
            this.drawerHeight = newHeight;
          }
        }
      },
      handleTouchEnd() {
        this.isDragging = false;

        // Animación para abrir o cerrar el drawer según la posición
        const screenHeight = window.innerHeight - 60;
        if (this.drawerHeight > screenHeight / 1.25) {
          this.drawerHeight = screenHeight;
        } else if (this.drawerHeight > screenHeight / 3 ) {
          this.drawerHeight = 500;
        }
        else{
          this.drawerHeight = 0;
        }
      },
      update_filters(){
        this.drawerHeight=0
        this.$emit("get-data-input", structuredClone(this.localInput));
      }
    },
  };
  </script>

  <style scoped>
    .form-check-input{
        height: 20px !important;
    }

    .form-check-input:checked {
        background-color: #15E0DD;
        border-color: #15E0DD;
    }

  </style>
